/**
 * @flow
 */

import React, { useCallback } from 'react';
import { Button } from 'semantic-ui-react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { switchSalon } from '../../../actions/user';

// `salon`/`salonName` drive the click handler and are not forwarded to Button.
function SwitchSalonButton({ salon, salonName, ...props }) {
    const dispatch = useDispatch();
    const history = useHistory();

    const onClick = useCallback(() => {
        dispatch(switchSalon(salon, salonName));
        history.push('/salon/appointments');
    }, [dispatch, salon, salonName, history]);

    return <Button {...props} onClick={onClick} />;
}

export default SwitchSalonButton;
